import { icons } from "assets";
import { RouteAwareCrumbs } from "Components/shared/breadcrumbs";
import { Tab, TabPanel, Tabs } from "Components/shared/tab";
import TableDisplay from "Components/shared/table";
import Text from "Components/shared/text";
import {
  EmptyComponent,
  Status,
  TransactionType,
} from "Components/shared/transactions";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetUsersTransactions } from "services/transactionService";
import { capitalize, convertDate } from "utils/stringServices";
import styles from "./debit.module.css";


const format = Intl.NumberFormat("en-US");
const dateFormat = Intl.DateTimeFormat("en-GB");

const tableStructure = {
  0: {
    field: "transactionType",
    renderItem: (rowData) => <TransactionType type={rowData.transactionType} />,
    cellStyle: {},
  },
  1: {
    renderItem: (rowData) => (
      <Text style={{ fontWeight: "300" }}>
        {capitalize(rowData.type)}: <br /> {rowData.details}
      </Text>
    ),
    cellStyle: {
      minWidth: "220px",
    },
  },
  2: {
    renderItem: (rowData) => (
      <Text style={{ fontWeight: "300" }}>
        Date:
        <br /> {convertDate(rowData.timestamp)}
      </Text>
    ),
    cellStyle: {
      minWidth: "110px",
    },
  },
  3: {
    renderItem: (rowData) => <Status variant={rowData.status} />,
    cellStyle: {
      textAlign: "left",
    },
  },
  4: {
    renderItem: (rowData) => (
      <Text
        style={{
          display: "flex",
          alignItems: "center",
          justifySelf: "flex-end",
        }}
      >
        ₦{format.format(rowData.amount)}
      </Text>
    ),
    cellStyle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      justifySelf: "flex-end",
      minWidth: "120px",
      flexGrow: 2,
      paddingRight: "24px",
    },
  },
};
const DebitCardHomeBody = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const handleChange = (e, tabIndex) => {
    setSelectedTab(tabIndex);
  };
  const NameMap = {
    "/transaction-history/naira-wallet": "Naira Wallet Transaction",
    "/transaction-history": "Transaction History",
  };

  const {
    status: transactStatus,
    error: transactError,
    data: transactData,
  } = useGetUsersTransactions("card");

  console.log(transactData)

  return (
    <div className={styles.root} style={{ padding: 0 }}>
      <div className={styles.contentContainer}>
        <Text
          variant="md2"
          tag="h2"
          style={{ fontWeight: "700", marginBottom: "24px" }}
        >
          Transactions
        </Text>
        <Tabs value={selectedTab} handleChange={handleChange} fullWidth>
          <Tab label="All" />
        </Tabs>
        <TabPanel value={selectedTab} index={0}>
          <TableDisplay
            data={transactData || []}
            column={tableStructure}
            emptyComponent={
              <div className={styles.emptyContainer}>
                <EmptyComponent
                  graphics={
                    <img
                      src={icons.empty_transaction}
                      alt="empty transactions"
                    />
                  }
                  title="Opps! You do not have any transaction history"
                  description="Looks like you do not have any transaction history. Send money to your wallet today to see your transaction history"
                  action={{
                    label: "Go to wallet",
                    onClick: (e) => {},
                    fullWidth: true,
                  }}
                />
              </div>
            }
          />
        </TabPanel>
      </div>
    </div>
  );
};

export default DebitCardHomeBody;
